import { APIResponse } from '@/types';
import httpService from './httpService';
import { ResetPasswordRequest, ResetPasswordResponse } from '@/types/pages/resetPassword';

export function resetPasswordAPI(data: ResetPasswordRequest): APIResponse<ResetPasswordResponse> {
    return httpService.post('/reset-data', data);
}
